import api from './api';

export const createStage = (data) => api.post('/stages/', data);

export const getStage = (id) => api.get(`/stages/${id}`);

export const updateStage = (id, data) => api.put(`/stages/${id}`, data);

export const updateStageStatus = (id, status) => api.put(`/stages/${id}/status`, { status });

export const reorderStage = (id, direction) => api.put(`/stages/${id}/reorder`, { direction });

export const deleteStage = (id) => api.delete(`/stages/${id}`);
